module.exports = __webpack_public_path__ + "static/media/log-out.355104c3.svg";